import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AuthProvider } from "./AuthProvider";
import { Toaster } from "sonner";
import { TopUpDialogProvider } from "./TopUpDialogContext";
import { queryClient } from "@/lib/query-client";

interface AppProvidersProps {
  children: React.ReactNode;
}

// Re-export queryClient for existing consumers
export { queryClient };

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TopUpDialogProvider>
          {children}
          <Toaster richColors position="top-center" />
        </TopUpDialogProvider>
      </AuthProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
};

export default AppProviders;
